import apiFetch from '../../apiFetch'

export default function (idEmpresa) {
  return apiFetch({endPoint: `admin/Empresa/getEmpresa?idEmpresa=${idEmpresa}`, method: 'GET', body: null})
}
